document.addEventListener("DOMContentLoaded", () => {
    document.querySelector('body').addEventListener('click', function(event) {
        // check if the clicked element or its parent is a button inside a .name class
        var button = event.target.closest('.name button');
        if (!button) return; // clicked element was not the button or inside the button
        
        var row = button.closest('tr');
        var bio = row.querySelector('.biography');
            
        if (bio.style.display === 'none') {
            button.setAttribute('aria-expanded', 'true')
            bio.style.display = 'block';
            bio.setAttribute('aria-hidden', 'false')
            row.classList.add('active'); // add the 'active' class
        } else {
            button.setAttribute('aria-expanded', 'false')
            bio.style.display = 'none';
            bio.setAttribute('aria-hidden', 'true')
            row.classList.remove('active'); // remove the 'active' class
        }
    });
});
